import * as React from "react";

const IconStockUnavailable: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 13"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fill="#E4104E" d="M6 .5a6 6 0 100 12 6 6 0 100-12zm1.877 7.102a.562.562 0 11-.795.795L6 7.295 4.898 8.397a.562.562 0 11-.796-.796L5.205 6.5 4.102 5.377a.562.562 0 11.795-.795L6 5.705l1.102-1.102a.562.562 0 11.796.796L6.795 6.5l1.082 1.1z"/></svg>;
};

export default React.memo(IconStockUnavailable);
